module.exports = __webpack_public_path__ + "static/media/lds-logo_hr.b0cdee5a.svg";